<template>
  <div class="container">
    <div class="tabs is-centered" style="background-color: #FFFFFF;">
      <ul style="margin: 0">
        <li :class="{'is-active': activeIndex === index}"
            v-for="(tab,index) in tabsData" :key="index" @click="changeTabs(index)">
          <a>
            <span class="label-input">{{ $t(`pages.${tab.name}`) }}</span>
            <div class="badge-color">
              ({{ tab.count === null ? '-' : tab.count }})
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div class="tab-item">
        <keep-alive>
          <component :is="selectedTab.component"
                     :ref="selectedTab.ref"
                     @dataCountUpdated="updateDataCount"
                     :checkUser="checkUser"/>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ParcelInbound from "@views/SuperAdmin/Parcel/ParcelBranch/TabStatus/Parcel-Inbound";
import ParcelInboundWaiting from "@views/SuperAdmin/Parcel/ParcelBranch/TabStatus/Parcel-Un-Inbound";
import ParcelOutBound from "@views/SuperAdmin/Parcel/ParcelBranch/TabStatus/ParcelOutBound";
import ParcelOutBoundWaiting from "@views/SuperAdmin/Parcel/ParcelBranch/TabStatus/Parcel-UnOutBound";

export default {
  name: "Index",
  computed: {
    selectedTab() {
      return this.tabsData[this.activeIndex]
    },
  },
  data() {
    return {
      activeIndex: 0,
      tabsData: [
        {
          name: "ເຄື່ອງຄ້າງສາງ",
          component: ParcelOutBoundWaiting,
          count: null,
          ref: 'unOutbound'
        },
        {
          name: "ຍິງເຄື່ອງອອກ",
          component: ParcelOutBound,
          count: null,
          ref: 'outbound'
        },
        {
          name: "ຍິງເຄື່ອງເຂົ້າ",
          component: ParcelInbound,
          count: null,
          ref: 'inbound'
        },
        {
          name: "ລໍຖ້າຍິງເຂົ້າ",
          component: ParcelInboundWaiting,
          count: null,
          ref: 'unInbound'
        }
      ],
      checkUser: {
        branch: {}
      },
    }
  },
  methods: {
    changeTabs(index) {
      this.activeIndex = index;
    },
    updateDataCount(dataCount) {
      this.tabsData[this.activeIndex].count = dataCount.count || 0;
    },
  },
  watch: {
    checkUser: function (val) {
      if (val && val.branch) {
        this.$store.commit("set_BranchId", val.branch == null ? 1 : val.branch.id)
      }
    }
  },
  created() {
    this.$http.get(`list-my-profile`).then((res) => {
      this.checkUser = res.data;
      if (this.checkUser && this.checkUser.branch) {
        this.$store.commit("set_BranchId", this.checkUser.branch.id)
      } else {
        this.$store.commit("set_BranchId", 1)
      }
      const unOutboundRef = this.$refs.unOutbound;
      if(unOutboundRef) {
        unOutboundRef.firstInit()
      }
    }).catch(() => {
    })
    if (this.$can('service')) {
      this.$store.commit("set_service_role", "service")
    }
  }
}
</script>

<style scoped lang="scss">
.badge-color {
  font-weight: 900;
  margin-left: 12px;
  color: red;
}
</style>
